import { render, staticRenderFns } from "./MilonStats.vue?vue&type=template&id=4f2d4695&scoped=true"
import script from "./MilonStats.vue?vue&type=script&lang=js"
export * from "./MilonStats.vue?vue&type=script&lang=js"
import style0 from "./MilonStats.vue?vue&type=style&index=0&id=4f2d4695&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d4695",
  null
  
)

export default component.exports